import React from "react";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
import { configBot, theme } from "./styles";

import Suport from "../../components/Suport";

function Chatbot() {
  return (
    <ThemeProvider theme={theme}>
      <ChatBot
        {...configBot}
        placeholder="Digite aqui..."
        steps={[
          {
            id: "welcome",
            message:
              "Olá! Se tiver alguma dúvida estou aqui para te ajudar, ok? ",
            trigger: "loadingresponseuser"
          },
          {
            id: "loadingresponseuser",
            user: true,
            trigger: "suport"
          },
          {
            id: "suport",
            component: <Suport />,
            end: true
          }
        ]}
      />
    </ThemeProvider>
  );
}

export default Chatbot;
